module.exports = __webpack_public_path__ + "static/media/OurAchievements_Mobile.17dd1565.svg";